import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
// // import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';


import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    LoadingBlock,
} from '../../components';

import {IconImg} from '../../components/Icon'

import {
    EtherToInt,
    ShortAddress
} from '../../ethers/e'

import { memo } from 'react';
import { utils } from 'ethers';

import {
    useNodeData,
    useBuyNode,
    useClaim,
    useClaimNode
} from '../../hook/v2/useNode'

import {
    useBalance
} from '../../context/balance'

import {ProtocolSignDrawer} from '../Protocol'

import Loading from './Loading'


// const COLORS = {
//     up: "#f13232",
//     down: '#1ce81c'
// }
const Price = memo(function () {
    const p = useBalance()
    return (
        <div style={{textAlign:'right'}}>
            <TextS style={{lineHeight: '12px'}} block>CVC<TextS color='2'> / USDT </TextS></TextS>
            <TextS style={{lineHeight: '20px', fontSize: '16px'}}>{p.prices.CVC.toFixed(6)} {/*<TextS style={{color: COLORS.up}}>+ 0.36%</TextS>*/}</TextS>
        </div>
    )
})

function ClaimUSDT() {
    return <Button {...useClaim()}/> 
}

function ClaimNodeUSDT() {
    return <Button {...useClaimNode()}/> 
}

const NODE_MAX_INVEST = 3000
const RANK_REWARD_MAX = 3000
const NODE_MAX_WEI = utils.parseUnits(String(NODE_MAX_INVEST), 18)
const isNodeFull = invested => utils.parseUnits(String(invested || 0), 18).gte(NODE_MAX_WEI)

function InvestProcess(amountInput, usdtInvested) {
    const invested = utils.parseUnits(String(usdtInvested || 0), 18)
    let amount
    try {
        amount = utils.parseUnits(String(amountInput || 0), 18)
    } catch (e) {
        amount = NODE_MAX_WEI.sub(NODE_MAX_WEI)
    }
    const total = invested.add(amount.gt(0) ? amount : 0)
    if (total.gte(NODE_MAX_WEI)) return '100.00'
    const hundredths = total.mul(10000).div(NODE_MAX_WEI).toNumber()
    return (Math.max(0, hundredths) / 100).toFixed(2)
}

function RankRewardProcess(rewardedUSDT) {
    const p = (rewardedUSDT * 1) / RANK_REWARD_MAX * 100
    return Math.max(0, Math.min(p, 100)).toFixed(2)
}

function RankAt(id, t) {
    return id === '--' || id === undefined || id === null ? '--' : `${t('At.')}${id}`
}

function JoinNode({registed, usdtInvested}) {
    const {t} = useTranslation()
    const p = useBalance()
    const {
        button,
        sponsorInput,
        hashInput,
        amountInput
    } = useBuyNode(usdtInvested)
    
    const requireSign = hashInput.value === ''

    if (isNodeFull(usdtInvested)) return null

    const investProcess = InvestProcess(amountInput.value , usdtInvested)
    const max = () => {
        const invested = utils.parseUnits(String(usdtInvested || 0), 18)
        const remaining = invested.gte(NODE_MAX_WEI) ? NODE_MAX_WEI.sub(NODE_MAX_WEI) : NODE_MAX_WEI.sub(invested)
        const balance = utils.parseUnits(String(p.balances.USDT || 0), 18)
        amountInput.onChange(utils.formatUnits(balance.lt(remaining) ? balance : remaining, 18))
    }
    return (
        <Card>
            <TextL block>{t('Join Node')}</TextL>
            <FlexBLock>
                <TextS>{t('Invested')} <TextLinear>{usdtInvested}</TextLinear> USDT</TextS>
                <TextS>{t('Balance')} <TextLinear>{EtherToInt(p.balances.USDT)}</TextLinear> USDT</TextS>
            </FlexBLock>
            <Input
                after={<Button size='small' type='a' onClick={max}>{t('Max')}</Button>}
                input={amountInput}
            />
            <WhiteSpace />
            <FlexBLock>
                <TextS>{t('Invest 3,000 USDT into Node')}</TextS>
                <TextS>{investProcess}%</TextS>
            </FlexBLock>
            <Loading progress={investProcess}/>
            {
                !registed &&
                <>
                    <WhiteSpace />
                    <TextS>{t('Sponsor Address')}</TextS>
                    <Input
                        // after={<Button size='small' type='d' onClick={()=>{}}>Max</Button>}
                        input={sponsorInput}
                    />
                </>
                
            }
            
            <WhiteSpace />
            {
                requireSign ? 
                <ProtocolSignDrawer
                    buttonStyle={{
                        type:'b',
                        style: {width: '100%'}
                    }}
                    onComfirm={hash => {
                        // console.log(hash, " hash")
                        hashInput.onChange(hash)
                    }}
                />:
                <Button type='b' style={{width: '100%'}} {...button}/>
            }
            <WhiteSpace />
            <Hr/>
            <WhiteSpace />
            <TextM>{t('Node Purchase Rules')}</TextM>
            <RulesBlock>
                <TextM block>{t('Node V2')}:</TextM>
                <TextS block>· {t('Node registration must be completed before a user can refer other nodes.')}</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>{t('Rewards')}:</TextM>
                <TextS block>· {t('Direct Referral Bonus')}: 10%</TextS>
                <TextS block>· {t('Indirect Referral Bonus')}: 10%</TextS>
                <TextS block>· {t('Team Bonus')}: 10%</TextS>
                <TextS block>· LP: 35%</TextS>
                <TextS block>· {t('Global Public Queue')}: 30%</TextS>
                <TextS block>· {t('Global Accelerated Public Queue: priority is based on the number of direct and indirect referrals. Users with more referrals and higher contribution value are queued first. If the contribution value is the same, priority follows the earlier timestamp.')}</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>{t('Insurance Fund')}:</TextM>
                <TextS block>· {t('Insurance (Risk Control) Fund: 5%, used to protect the last 100 nodes and the last 100 stair users.')}</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>{t('Withdrawal Fee')}:</TextM>
                <TextS block>· {t('Withdrawal Fee')}: 20%</TextS>
                <TextS block>· {t('Community')}: 10%</TextS>
                <TextS block>· DAO: 10%</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>{t('Node Benefits')}:</TextM>
                <TextS block>· {t('Receive Level 13 in the stair system.')}</TextS>
                <TextS block>· {t('Receive 3,000 CVC.')}</TextS>
                <TextS block>· {t('The public queue can return 100% of the principal.')}</TextS>
                <TextS block>· {t('Nodes can upgrade by contribution value and receive community dividends.')}</TextS>
                <TextS block>· {t('Direct referral, indirect referral, and team reward policies.')}</TextS>
                <TextS block>· {t('Protection from the risk control fund.')}</TextS>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <TextM block>{t('Team Leader (Community)')}:</TextM>
                <TextS block>· {t('Team Leader standards are triggered and generated by the smart contract.')}</TextS>
                <TextS block>· {t('When a node completes 1, 3, 9, and 27, the contract automatically upgrades the user to Team Leader.')}</TextS>
                <TextS block>· {t('Team Leader benefit: 50% of network-body revenue is distributed instantly to the Team Leader address.')}</TextS>
            </RulesBlock>
        </Card>
    )
}

const IDENTITY_TYPE = ["User", "User", "Node", "FullNode", "Leader", "TeamLeader"]
function TeamItem({user, vip, identity, invested, ...prop}) {
    const {t} = useTranslation()
    return (
        <FlexBLock {...prop}>
            <TextS>{ShortAddress(user, 6)} - [{EtherToInt(invested)} U]</TextS>
            <div><NodeType>VIP{vip}</NodeType> <NodeType i={identity + 1}>{t(IDENTITY_TYPE[identity] || IDENTITY_TYPE[0])}</NodeType></div>
        </FlexBLock>
    )
}

function Node() {
    const {t} = useTranslation()
    const node = useNodeData()
    const showJoinNode = !isNodeFull(node.usdtInvested)
    
    const isNodeOrAbove = (node.identity * 1) >= 2
    const hasLockedTeamReward = !isNodeOrAbove && (node.teamReward * 1) > 0
    const rankRewardProcess = RankRewardProcess(node.rankTopPending)

    return (
        <Container>
            {/* <FlexBLock>
                
            </FlexBLock>
            <WhiteSpace /> */}
            <FlexBLock>
                <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./togetherness.png'/> Node V2</TextMax>
                <Price />
            </FlexBLock>
            <Card type='j'>
                
                <WhiteSpace />
                {/* <div style={{textAlign: 'center'}}>
                    <TextM block>{t('Reserve USDT')}</TextM>
                    <TextLinear linear='3' style={{fontSize: '34px'}} >{EtherToInt(node.totalInvested)}</TextLinear>
                </div> */}
                <div style={{textAlign: 'center'}}>
                    <TextM block>Reserve USDT</TextM>
                    <TextLinear linear='3' style={{fontSize: '34px'}} >{EtherToInt(node.totalInvested)}</TextLinear>
                </div>
                {/* <FlexBLock>
                    <TextM></TextM>
                    <TextM>{EtherToInt(1000000000)} <TextS color='2'>USDT</TextS></TextM>
                </FlexBLock> */}
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <div>
                        <TextS block color='2'> {t('Security Address')}</TextS>
                        <TextM>{ShortAddress(node.securityTreasuryAddress)}</TextM> 
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextS block color='2'>{t('V2 Security Treasury')} {/**<NodeType>NO.{node.userRankId}</NodeType> */}</TextS>
                        <TextM>{EtherToInt(node.securityTreasuryUSDT)} <TextS color='2'>USDT</TextS></TextM>
                    </div>
                </FlexBLock>
            </Card>
            <WhiteSpace />
            <Card type='j'>
                <TextL block style={{marginBottom: '10px'}}>
                    {/* <IconImg style={{width: '20px', height: 'auto', verticalAlign: 'middle', marginRight: '5px'}} src='./prize.png'/> */}
                    {t('Rank Prize Pool')}
                </TextL>
                <FlexBLock>
                    <div>
                        <TextS block color='2'>{t('Top Address')} - <TextS>{RankAt(node.rankHeadId, t)}</TextS></TextS>
                        <TextM>{ShortAddress(node.rankHeadAddress)}</TextM> 
                    </div>
                    <div style={{textAlign:'right'}}>
                        <TextS block color='2'>{t('Top Performance')} {/**<NodeType>NO.{node.userRankId}</NodeType> */}</TextS>
                        <TextM>{EtherToInt(node.rankRewardedUSDT)} <TextS color='2'>USDT</TextS></TextM>
                    </div>
                </FlexBLock>
                <WhiteSpace />
                <FlexBLock>
                    <TextS color='2'>{t('Pending Rewards')}</TextS>
                    <TextS>{EtherToInt(node.rankTopPending)} <TextS color='2'>USDT</TextS> / {rankRewardProcess}%</TextS>
                </FlexBLock>
                <Loading progress={rankRewardProcess}/>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                {
                    node.rankDisqualified ?
                    <div>
                        <TextS block>{t('My Rank Rewarded')}</TextS>
                        <FlexBLock>
                            <TextS color='2'>{t('Withdrawn')}</TextS>
                            <TextS>3,000 <TextS color='2'>USDT</TextS></TextS>
                        </FlexBLock>
                    </div> :
                    <FlexBLock>
                        <div>
                            <TextS block>{t('My Rank Rewarded')}</TextS>
                            <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(node.totalClaim)}</TextLinear>
                            <TextM color='2'> / USDT</TextM>
                        </div>
                        <ClaimUSDT />
                    </FlexBLock>
                }
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextS color='2'>{t('My Rank Position')}</TextS>
                    <TextS>{RankAt(node.userRankId, t)}</TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('My Direct Performance')}</TextS>
                    <TextS>{EtherToInt(node.directPerformance)} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('My Indirect Performance')}</TextS>
                    <TextS>{EtherToInt(node.level2Performance)} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
            </Card>
            <WhiteSpace />
            <Card type='j'>
                <TextL block style={{marginBottom: '10px'}}> {t('Node Rewards')}</TextL>
                <FlexBLock>
                    <div>
                        <TextS block>{isNodeOrAbove ? t('Withdrawable') : t('Potential Rewards')}</TextS>
                        <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(node.nodeClaim)}</TextLinear> <TextM color='2'> / USDT</TextM>
                        <TextS block color='2'>{t('Total Rewarded')} <TextS>{EtherToInt(node.totalClaimed)}</TextS> USDT</TextS>
                    </div>
                    {isNodeOrAbove ? <ClaimNodeUSDT /> : null}
                </FlexBLock>
                {
                    !isNodeOrAbove &&
                    <>
                        <WhiteSpace />
                        <TextS color='2' block>{t('Upgrade to Node to unlock and receive these rewards immediately.')}</TextS>
                    </>
                }
                
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextS color='2'>{t('My Direct Reward')}</TextS>
                    <TextS>{EtherToInt(node.directReward)} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('My Indirect Reward')}</TextS>
                    <TextS>{EtherToInt(node.level2Reward)} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('My Team Reward')}</TextS>
                    <TextS color={node.identity === 0 ? '2': '1'}>{EtherToInt(node.teamReward)} <TextS color='2'>USDT</TextS></TextS>
                </FlexBLock>
                {
                    node.feeReaward * 1 > 0 &&
                    <FlexBLock>
                        <TextS color='2'>{t('My Fee Reward')}</TextS>
                        <TextS >{EtherToInt(node.feeReaward)} <TextS color='2'>USDT</TextS></TextS>
                    </FlexBLock>
                }
                {
                    hasLockedTeamReward &&
                    <TextS color='2' block>{t('Team Reward is visible but locked. Upgrade to Node to claim it.')}</TextS>
                }
                
                
            </Card>
            <WhiteSpace />
            {
                // node.isNode === null?
                // <div style={{textAlign: 'center'}}>
                //     <CircularProgress color="inherit"/>
                // </div>:
                // node.isNode === true ?
                <>
                    {
                        showJoinNode ?
                        <>
                            <JoinNode registed={node.registed} usdtInvested={node.usdtInvested}/>
                            <WhiteSpace />
                        </> : null
                    }
                    <Card type='b' spacing={[0,0]} >
                        <TextM style={{padding: '0.6rem', display: 'flex', alignItems: 'center' }}>{t('My Team')} <NodeType>VIP{node.levels}</NodeType> <NodeType i={5}>{t(IDENTITY_TYPE[node.identity] || IDENTITY_TYPE[0])}</NodeType></TextM>
                        <Card>
                            <LoadingBlock>
                                {
                                    node.tree.map((v) => {
                                        return (
                                            <div key={v.user} style={{margin: '10px 0px 0px'}}>
                                                <TeamItem
                                                    user={v.user}
                                                    vip={v.vip}
                                                    identity={v.identity}
                                                    invested={v.invested}
                                                    style={{marginBottom: '8px'}}
                                                />
                                                {
                                                    v.children.map(v=> {
                                                        return (
                                                            <div key={v.user} style={{margin: '0px 0px 5px 16px'}}>
                                                                <TeamItem
                                                                    user={v.user}
                                                                    vip={v.vip}
                                                                    identity={v.identity}
                                                                    invested={v.invested}
                                                                />
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <WhiteSpace />
                                                <Hr />
                                            </div>
                                        )
                                    })
                                }
                            </LoadingBlock>
                        </Card>
                    </Card>

                </>
            }
        </Container>
    )
}

export default Node

const COLOR = [
    "rgb(171 255 0)",
    "rgb(171 255 0)",
    "rgb(168 195 255)",
    "rgb(255 241 0)",
    "rgb(255 0 161)",
    "rgb(0 242 255)",
    "rgb(255 244 150)"
]
function NodeType({children, i = 0}) {
    return <NodeBlock i={i}>{children}</NodeBlock>
}

const NodeBlock = styled('span')`
    background-color: ${p => COLOR[p.i] || COLOR[0]};
    color: #000;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 4px;
    box-shadow: 0px 0px 6px #fdffb791;
`

const RulesBlock = styled('div')`
    background: rgb(9 9 9 / 82%);
    padding: 12px;
    border-radius: 12px;
    margin: 8px 0px;
`
